import React, { useState, useEffect } from 'react';
import { 
  Container, Row, Col, Card, CardHeader, CardBody, Table, Button, 
  FormGroup, Label, Input, Nav, NavItem, NavLink, Navbar, NavbarBrand 
} from 'reactstrap';
import { Line, Pie, Bar } from 'react-chartjs-2';

// Service Layer - Simulating API calls
const DashboardService = {
  getLeaderboardData: async (filters) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const data = [
          { user_id: 1, user_name: 'Alex Johnson', score: 1250, game_type: 'Action', game_name: 'Battle Arena', publisher: 'Publisher A', last_played: '2025-10-28' },
          { user_id: 2, user_name: 'Maria Garcia', score: 1180, game_type: 'Puzzle', game_name: 'Brain Teaser', publisher: 'Publisher B', last_played: '2025-10-27' },
          { user_id: 3, user_name: 'James Smith', score: 1320, game_type: 'Adventure', game_name: 'Quest Master', publisher: 'Publisher A', last_played: '2025-10-28' },
          { user_id: 4, user_name: 'Emily Chen', score: 1090, game_type: 'Action', game_name: 'Speed Racer', publisher: 'Publisher C', last_played: '2025-10-26' },
          { user_id: 5, user_name: 'David Brown', score: 1400, game_type: 'Puzzle', game_name: 'Logic Pro', publisher: 'Publisher B', last_played: '2025-10-28' },
          { user_id: 6, user_name: 'Sarah Wilson', score: 1150, game_type: 'Adventure', game_name: 'Explorer', publisher: 'Publisher A', last_played: '2025-10-27' },
          { user_id: 7, user_name: 'Michael Lee', score: 1280, game_type: 'Action', game_name: 'Combat Zone', publisher: 'Publisher C', last_played: '2025-10-28' },
          { user_id: 8, user_name: 'Lisa Taylor', score: 1220, game_type: 'Puzzle', game_name: 'Mind Games', publisher: 'Publisher B', last_played: '2025-10-26' },
        ];
        
        let filtered = data;
        if (filters.gameType) {
          filtered = filtered.filter(item => item.game_type === filters.gameType);
        }
        if (filters.publisher) {
          filtered = filtered.filter(item => item.publisher === filters.publisher);
        }
        
        resolve(filtered.sort((a, b) => b.score - a.score));
      }, 300);
    });
  },

  getScoreDistribution: async (filters) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const data = {
          labels: ['Action', 'Puzzle', 'Adventure', 'Sports', 'Strategy'],
          datasets: [{
            data: [4200, 3100, 2800, 1900, 2500],
            backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF'],
            hoverBackgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF']
          }]
        };
        resolve(data);
      }, 300);
    });
  },

  getTrendingGames: async (filters) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const timeLabels = filters.dateRange === 'last_24_hours' 
          ? ['00:00', '04:00', '08:00', '12:00', '16:00', '20:00']
          : filters.dateRange === 'weekly'
          ? ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          : ['Week 1', 'Week 2', 'Week 3', 'Week 4'];
        
        const data = {
          labels: timeLabels,
          datasets: [
            {
              label: 'Battle Arena',
              data: [220, 380, 520, 680, 820, 950],
              borderColor: '#FF5733',
              backgroundColor: 'rgba(255, 87, 51, 0.1)',
              fill: true,
              tension: 0.4
            },
            {
              label: 'Brain Teaser',
              data: [150, 280, 420, 580, 690, 800],
              borderColor: '#33FF57',
              backgroundColor: 'rgba(51, 255, 87, 0.1)',
              fill: true,
              tension: 0.4
            },
            {
              label: 'Quest Master',
              data: [180, 320, 480, 620, 740, 880],
              borderColor: '#3357FF',
              backgroundColor: 'rgba(51, 87, 255, 0.1)',
              fill: true,
              tension: 0.4
            }
          ]
        };
        resolve(data);
      }, 300);
    });
  },

  getGamePerformance: async () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const data = {
          labels: ['Battle Arena', 'Brain Teaser', 'Quest Master', 'Speed Racer', 'Logic Pro'],
          datasets: [{
            label: 'Total Players',
            data: [1250, 980, 1100, 850, 920],
            backgroundColor: 'rgba(75, 192, 192, 0.6)',
            borderColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 1
          }]
        };
        resolve(data);
      }, 300);
    });
  }
};

// Filter Component
const Filters = ({ filters, onFilterChange, onApplyFilters }) => {
  return (
    <Card className="mb-4">
      <CardHeader className="bg-dark text-white">
        <strong>🔍 Filters</strong>
      </CardHeader>
      <CardBody>
        <Row>
          <Col md={3}>
            <FormGroup>
              <Label for="gameType">Game Type</Label>
              <Input
                type="select"
                name="gameType"
                id="gameType"
                value={filters.gameType}
                onChange={onFilterChange}
              >
                <option value="">All Types</option>
                <option value="Action">Action</option>
                <option value="Puzzle">Puzzle</option>
                <option value="Adventure">Adventure</option>
                <option value="Sports">Sports</option>
                <option value="Strategy">Strategy</option>
              </Input>
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label for="publisher">Publisher</Label>
              <Input
                type="select"
                name="publisher"
                id="publisher"
                value={filters.publisher}
                onChange={onFilterChange}
              >
                <option value="">All Publishers</option>
                <option value="Publisher A">Publisher A</option>
                <option value="Publisher B">Publisher B</option>
                <option value="Publisher C">Publisher C</option>
              </Input>
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label for="dateRange">Date Range</Label>
              <Input
                type="select"
                name="dateRange"
                id="dateRange"
                value={filters.dateRange}
                onChange={onFilterChange}
              >
                <option value="last_24_hours">Last 24 Hours</option>
                <option value="weekly">Last Week</option>
                <option value="monthly">Last Month</option>
              </Input>
            </FormGroup>
          </Col>
          <Col md={3} className="d-flex align-items-end">
            <FormGroup className="w-100">
              <Button color="primary" className="w-100" onClick={onApplyFilters}>
                Apply Filters
              </Button>
            </FormGroup>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

// Leaderboard Component
const OverallLeaderboard = ({ data, loading }) => {
  const exportData = () => {
    const csv = [
      ['Rank', 'User ID', 'User Name', 'Score', 'Game Type', 'Game Name', 'Publisher'],
      ...data.map((player, index) => [
        index + 1,
        player.user_id,
        player.user_name,
        player.score,
        player.game_type,
        player.game_name,
        player.publisher
      ])
    ].map(row => row.join(',')).join('\n');
    
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'leaderboard.csv';
    a.click();
  };

  return (
    <Card className="mb-4">
      <CardHeader className="bg-primary text-white d-flex justify-content-between align-items-center">
        <span><strong>🏆 Overall Leaderboard</strong></span>
        <Button color="light" size="sm" onClick={exportData}>
          📥 Export
        </Button>
      </CardHeader>
      <CardBody>
        {loading ? (
          <div className="text-center py-5">Loading...</div>
        ) : (
          <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
            <Table striped hover responsive>
              <thead style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
                <tr>
                  <th>Rank</th>
                  <th>User ID</th>
                  <th>User Name</th>
                  <th>Score</th>
                  <th>Game Type</th>
                  <th>Game Name</th>
                  <th>Publisher</th>
                </tr>
              </thead>
              <tbody>
                {data.map((player, index) => (
                  <tr key={player.user_id}>
                    <td>
                      {index === 0 && '🥇'}
                      {index === 1 && '🥈'}
                      {index === 2 && '🥉'}
                      {index > 2 && index + 1}
                    </td>
                    <td>{player.user_id}</td>
                    <td><strong>{player.user_name}</strong></td>
                    <td><span className="badge bg-success">{player.score}</span></td>
                    <td>{player.game_type}</td>
                    <td>{player.game_name}</td>
                    <td>{player.publisher}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

// Score Distribution Component
const ScoreDistribution = ({ data, loading }) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
      },
      title: {
        display: false
      }
    }
  };

  return (
    <Card className="mb-4">
      <CardHeader className="bg-info text-white">
        <strong>📊 Score Distribution by Game Type</strong>
      </CardHeader>
      <CardBody>
        {loading ? (
          <div className="text-center py-5">Loading...</div>
        ) : (
          <div style={{ height: '300px' }}>
            <Pie data={data} options={options} />
          </div>
        )}
      </CardBody>
    </Card>
  );
};

// Trending Games Component
const TrendingGames = ({ data, loading }) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: false
      }
    },
    scales: {
      y: {
        beginAtZero: true
      }
    }
  };

  return (
    <Card className="mb-4">
      <CardHeader className="bg-success text-white">
        <strong>📈 Trending Games (Most Played)</strong>
      </CardHeader>
      <CardBody>
        {loading ? (
          <div className="text-center py-5">Loading...</div>
        ) : (
          <div style={{ height: '300px' }}>
            <Line data={data} options={options} />
          </div>
        )}
      </CardBody>
    </Card>
  );
};

// Game Performance Component
const GamePerformance = ({ data, loading }) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      }
    },
    scales: {
      y: {
        beginAtZero: true
      }
    }
  };

  return (
    <Card className="mb-4">
      <CardHeader className="bg-warning text-dark">
        <strong>📊 Game Performance (Total Players)</strong>
      </CardHeader>
      <CardBody>
        {loading ? (
          <div className="text-center py-5">Loading...</div>
        ) : (
          <div style={{ height: '300px' }}>
            <Bar data={data} options={options} />
          </div>
        )}
      </CardBody>
    </Card>
  );
};

// Main Dashboard Component
const AdminDashboard = () => {
  const [filters, setFilters] = useState({
    gameType: '',
    publisher: '',
    dateRange: 'last_24_hours'
  });

  const [leaderboardData, setLeaderboardData] = useState([]);
  const [scoreDistribution, setScoreDistribution] = useState({});
  const [trendingGames, setTrendingGames] = useState({});
  const [gamePerformance, setGamePerformance] = useState({});
  const [loading, setLoading] = useState(true);

  const loadDashboardData = async () => {
    setLoading(true);
    try {
      const [leaderboard, distribution, trending, performance] = await Promise.all([
        DashboardService.getLeaderboardData(filters),
        DashboardService.getScoreDistribution(filters),
        DashboardService.getTrendingGames(filters),
        DashboardService.getGamePerformance()
      ]);

      setLeaderboardData(leaderboard);
      setScoreDistribution(distribution);
      setTrendingGames(trending);
      setGamePerformance(performance);
    } catch (error) {
      console.error('Error loading dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadDashboardData();
  }, []);

  const handleFilterChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value
    });
  };

  const handleApplyFilters = () => {
    loadDashboardData();
  };

  return (
    <div className="min-vh-100" style={{ backgroundColor: '#f5f7fa' }}>
      <Navbar color="dark" dark expand="md" className="mb-4">
        <Container fluid>
          <NavbarBrand href="/">
            <strong>⚡ Admin Dashboard</strong>
          </NavbarBrand>
          <Nav className="ms-auto" navbar>
            <NavItem>
              <NavLink className="text-white">
                🔔 Notifications
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink className="text-white">
                👤 Admin
              </NavLink>
            </NavItem>
          </Nav>
        </Container>
      </Navbar>

      <Container fluid>
        <Row className="mb-4">
          <Col>
            <h2 className="mb-0">Performance Analytics</h2>
            <p className="text-muted">Monitor user and game performance metrics</p>
          </Col>
        </Row>

        <Filters 
          filters={filters} 
          onFilterChange={handleFilterChange}
          onApplyFilters={handleApplyFilters}
        />

        <Row>
          <Col lg={12}>
            <OverallLeaderboard data={leaderboardData} loading={loading} />
          </Col>
        </Row>

        <Row>
          <Col lg={6}>
            <ScoreDistribution data={scoreDistribution} loading={loading} />
          </Col>
          <Col lg={6}>
            <GamePerformance data={gamePerformance} loading={loading} />
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            <TrendingGames data={trendingGames} loading={loading} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AdminDashboard